function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polyline", {
  points: "275.66,434.793 317.522,547.506 372.608,547.506 452.141,333.35 402.319,333.35 389.318,369.63 377.249,409.767  345.065,501.913 321.956,433.885 310.983,401.577 298.352,364.394 310.042,398.811 321.956,433.885 298.352,364.394 296.472,369.63  284.405,409.767 252.22,501.913 194.963,333.35 145.14,333.35 224.677,547.506 279.763,547.506 321.959,433.885 "
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M560.813,347.271c6.548,23.439,10.07,48.147,10.07,73.675c0,150.908-122.337,273.243-273.243,273.243 c-150.91,0-273.243-122.335-273.243-273.243S146.73,147.702,297.64,147.702c68.036,0,130.245,24.882,178.069,66.023 c3.576-1.304,7.435-2.013,11.456-2.013c18.446,0,33.4,14.951,33.4,33.396c0,18.445-14.954,33.396-33.4,33.396 c-18.442,0-33.396-14.951-33.396-33.396c0-4.318,0.83-8.439,2.319-12.226c-44.283-37.439-99.791-57.851-158.448-57.851 c-65.686,0-127.445,25.574-173.891,72.025C77.301,293.505,51.72,355.261,51.72,420.945s25.577,127.439,72.029,173.888 c46.445,46.448,108.205,72.029,173.891,72.029s127.441-25.577,173.891-72.029c46.445-46.448,72.026-108.203,72.026-173.888 c0-22.913-3.117-45.341-9.141-66.811l0.035-0.014c-0.467-1.375-0.73-2.843-0.73-4.378c0-7.545,6.117-13.662,13.662-13.662 c5.507,0,10.241,3.267,12.403,7.958c0,0,0.253,0.509,0.328,0.78C560.421,345.607,560.653,346.422,560.813,347.271z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M317.24,445.454"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "595.279px",
    height: "841.891px",
    viewBox: "0 0 595.279 841.891",
    enableBackground: "new 0 0 595.279 841.891",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.08c7bdfa.svg";
export { ForwardRef as ReactComponent };